module.exports = __webpack_public_path__ + "2512d92c6083154de7c7ca43b2dbe1fc.jpg";